import React from 'react';
import Icon from '../../../components/AppIcon';

const SettingsTab = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="border-b border-border bg-card">
      <div className="flex overflow-x-auto scrollbar-hide">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`flex items-center gap-2 px-4 md:px-6 py-3 md:py-4 text-sm md:text-base font-medium whitespace-nowrap transition-all duration-200 border-b-2 flex-shrink-0 ${
              activeTab === tab?.id
                ? 'border-primary text-primary bg-primary/5' :'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
          >
            <Icon name={tab?.icon} size={18} />
            <span>{tab?.label}</span>
            {tab?.badge && (
              <span className="ml-1 px-2 py-0.5 text-xs rounded-full bg-accent text-accent-foreground">
                {tab?.badge}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SettingsTab;